import React from "react";
import google from "../Images/GoogleReview.webp";
import rattings from "../Images/ratings.svg";

const GoogleRating = () => {
  return (
    <>
      <div className="review_box2">
        <a className="review_box" href="/customer-reviews" target="_blank">
          <div className="indem-rate">
            <img src={google} className="indem_googl" />
            <img src={rattings} className="indem_star" />
          </div>
          <p>Highly rated insurance website</p>
        </a>
      </div>
    </>
  );
};

export default GoogleRating;
